export const COLORS = {
  BRONZE: "#CD7F32",
  DARK_BROWN: "#5C4033",
  DARK_WINE: "#6F1D1B",
  MOCHA: "#967969",
  WHEAT: "#F5DEB3",
};
